var render = function render(){var _vm=this,_c=_vm._self._c;return _c('UBtn',{staticClass:"facebook-btn",attrs:{"color":"blue","size":"medium","block":""}},[_c('span',{staticClass:"facebook-btn__text"},[_vm._v("\n    Sign in with Facebook\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }